export const PageBlockSkipReason = {
    DUPLICATE: "duplicate-block",
    DUPLICATE_TITLE: "duplicate-title",
    INVALID: "invalid-block",
    INVALID_PARAMETERS: "invalid-parameters",
    MISSING: "missing-block",
    UNSUPPORTED_TYPE: "unsupported-type",
};
export const PageUnavailableReason = {
    MALFORMED: "malformed-page",
    MISSING: "missing-page",
    NO_SUPPORTED_BLOCKS: "no-supported-blocks",
};
